/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Select, Icon, Spin, Empty } from "antd";
import networkList from "../../../constants/networkList";
import postService from "../../../services/httpService";
import { OPTION_IDS } from "../../../constants/app-constants";
import Item from "antd/lib/list/Item";
class Select2multiple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      select2options: [],
      loading: false,
      selectdata: {},
      fetching: true,
    };
  }
  componentDidMount() {
 
    this.setState(
      (state) => ({
        selectdata: this.props.selectdata,
        select2options: [],
        loading: true,
      }),
      () => {
        if (this.props.selectdata.name === "otroom") {
          this.selectFetchCall();
        }
        if (this.props.selectdata.name === "departments") {
          this.selectFetchCall();
        }
        if (this.props.selectdata.name === "secretary_doctor_ids") {
          this.selectFetchCall();
        }
        if (this.props.selectdata.name === "queues-list") {
          this.selectFetchCall();
        }
        if (this.props.selectdata.name === "unit") {
          this.selectFetchCall();
        }
        if (this.props.selectdata.name === "exclude_services") {
          this.selectFetchCall();
        }
      }
    );
  
  }

  // componentDidUpdate(prevProps, pervState) {
  //   if (prevProps.selectdata.value != this.props.selectdata.value) {
  //     this.setState((state) => ({ selectdata: this.props.selectdata }));
  //   }
  // }

  handleChange(value) {
    console.log(`selected ${value}`);
  }

  onChange(value) {
    let { selectdata } = this.state;
    selectdata["value"] = value;

    // this.selectFetchCall();
    let text = null;

    this.state.select2options.map((data, key) => {
      if (data["id"] === value) {
        text = data["name"];
      }
    });

    selectdata["text"] = text;
    this.setState((state) => ({ selectdata: selectdata }));
    if (this.props.selectdata.name === "queues-list") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "service") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            serviceTime: data.service_time,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "room_opted") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            amount: data.amount,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "package_name") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            length_of_stay: data.length_of_stay,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "patient_list") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            serviceTime: data.service_time,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "departments") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            speciality: data.name,
            speciality_id: data.name,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "secretary_doctor_ids") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            amount: data.amount,
            text: text,
          });
        }
      });
    } else if (this.props.selectdata.name === "unit") {
      this.state.select2options.map((data, key) => {
        if (data.id === value) {
          this.props.onselectChanges({
            id: this.props.selectdata.name,
            name: this.props.selectdata.name,
            value: value,
            parrentMode: this.props.selectdata.parrentMode,
            parrentName: this.props.selectdata.parrentName,
            text: text,
          });
        }
      });
    } else {
      this.props.onselectChanges({
        id: this.props.selectdata.name,
        text: text,
        name: this.props.selectdata.name,
        value: value,
        parrentMode: this.props.selectdata.parrentMode,
        parrentName: this.props.selectdata.parrentName,
      });
    }
  }

  onBlur() {
    console.log("blur");
   
    // this.selectFetchCall(); this.selectFetchCall();
  }

  onFocus() {
    
    this.setState({ select2options: [], loading: true });
    // //console.log(this.props);
    this.selectFetchCall();
  }

  onSearch(val) {
    if (this.props.selectdata.name === "secretary_doctor_ids") {
      let payload = {
        data_count: 0,
        search_key: val,
      };

      postService("doctorsForSecretaries", "POST", payload).then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.name;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
 
  }

  selectFetchCall() {
    this.setState({ fetching: true });
    const {
      getProcedures,
      otRoomsDropdown,
      getDepartments,
      master_excludeServices,
      master_unit,
    } = networkList;

    if (this.props.selectdata.name === "exclude_services") {
      let { add_queue_payload, row_feild } = this.props;

   
      postService(master_excludeServices, "POST", {
        unitid: add_queue_payload["unit_id"]
          ? add_queue_payload["unit_id"]
          : null,
        service_group_id: row_feild["service_group"]
          ? row_feild["service_group"]
          : null,
      }).then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (
      this.props.selectdata.name === "surgery_procedure_name" ||
      this.props.selectdata.name === "additional_procedure" ||
      this.props.selectdata.name === "surgery"
    ) {
      postService(getProcedures, "GET", "null").then((res) => {
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "queues-list") {
      const { formData } = this.props;
      let obj = {
        queue_type: null,
        unit_id: null,
        workstation_id: null,
      };
      formData.map((item) => {
        if (item["name"] === "unit") {
          obj["unit_id"] = item["value"];
        }
        if (item["name"] === "workstation") {
          obj["workstation_id"] = item["value"];
        }
        if (item["name"] === "qCreateType") {
          obj["queue_type"] =
            item["value"] === "opdconsultation"
              ? "OPD Consultation"
              : item["value"] === "radiology"
              ? "Radiology"
              : null;
        }
      });
    postService("getRoomBasedonRadiology", "POST", { data: obj }).then(
        (res) => {
          if (res) {
            if (res.status) {
              let newData = [];
              if (res.data.length !== 0) {
                res.data.map((queue) => {
                  newData.push({
                    // id: queue["queue_list_id"],
                    // name: queue["room_name"],

                    id: queue["id"],
                    name: queue["name"],
                  });
                });
              }
              this.setState((state) => ({
                select2options: newData,
                loading: false,
                fetching: false,
              }));
            } else {
              this.setState({ fetching: false });
            }
          }
        }
      );
    }
    if (this.props.selectdata.name === "departments") {
      postService(getDepartments, "GET", "null").then((res) => {
        let duplication = [];
        let department = [];
        let departments = [];
        if (res) {
          if (res.status) {
            res.data.map((item) => {
              if (!department.includes(item["id"])) {
                department.push(item["id"]);
                departments.push(item);
              } else {
                duplication.push(item["id"]);
              }
            });
          }

       
          if (departments.length > 0) {
            this.setState((state) => ({
              select2options: departments,
              loading: false,
              fetching: false,
            }));
          }
        } else {
          this.setState({ fetching: false });
        }
      });
    }
    if (this.props.selectdata.name === "secretary_doctor_ids") {
  

      let secretary_doctor = null;
      let payload = {
        data_count: 0,
        search_key: "",
      };

      postService("doctorsForSecretaries", "POST", payload).then((res) => {
        if (res) {
          let data = res.data;
          if (secretary_doctor && secretary_doctor.length > 0) {
            secretary_doctor.map((index) => {
              data.push(index);
            });
          } else {
            if (
              this.props.selectdata &&
              this.props.selectdata.value &&
              this.props.selectdata.value.length > 0
            ) {
              this.props.selectdata.value.map((index) => {
                data.push(index);
              });
            }
          }

          this.setState((state) => ({
            select2options: data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
    if (this.props.selectdata.name === "unit") {
      postService(master_unit, "GET", "null").then((res) => {
     
        if (res) {
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
  }

  getQueuevalue(name) {
    let { Queuedata } = this.props;
    let value = null;
    Queuedata.filter((data) => {
      if (data["name"] === name && data["valid"]) {
        value = data["value"];
      }
    });
    return value;
  }
  getFormvalue(name) {
    let { formData } = this.props;
    let value = null;
    formData.filter((data) => {
      if (data["name"] === name && data["valid"]) {
        value = data["value"];
      }
    });
    return value;
  }

  render() {
    const { fetching } = this.state;
    // console.clear();
    let mode = "multiple";
    let defvalue = null;
    let valueText = this.state.selectdata.text
      ? this.state.selectdata.text
      : null;
   const Option = Select.Option;
    const children = [];
    if (this.state.select2options.length !== 0) {
      this.state.select2options.map((data, key) => {
        if (data.id !== null) {
          children.push(
            <Option key={key} value={data.id}>
              {data.name ? data.name : data.value}
            </Option>
          );
        }
      });
    }
    if (
      this.props.selectdata.name === "additional_procedure" ||
      this.props.selectdata.name === "otroom" ||
      this.props.selectdata.name === "departments" ||
      this.props.selectdata.name === "secretary_doctor_ids" ||
      this.props.selectdata.name === "queues-list" ||
      this.props.selectdata.name === "unit" ||
      this.props.selectdata.name === "exclude_services"
    ) {
      mode = "multiple";
      defvalue = [];
      valueText = [];
    }

    let selected_value = [];
    if (
      this.state.selectdata &&
      this.state.selectdata["value"] &&
      Array.isArray(this.state.selectdata["value"])
    ) {
      this.state.selectdata["value"].map((data) => {
        if (this.props.selectdata.name === "queues-list") {
          this.state.select2options.map((queue, skey) => {
            if (
              (data &&
                data["id"] &&
                data["id"] === queue["id"] &&
                queue["id"]) ||
              (data && data === queue["id"] && queue["id"])
            ) {
              selected_value.push(queue["id"]);
              defvalue.push(queue["name"]);
            } else {
              if (
                data &&
                data["queue_list_id"] &&
                data["queue_list_id"] === queue["id"] &&
                queue["id"]
              ) {
                selected_value.push(queue["id"]);
                defvalue.push(queue["name"]);
              }
            }
          });
        }
        if (this.props.selectdata.name === "departments") {
          this.state.select2options.map((departments, skey) => {
            if (
              (data["id"] && data["id"] === departments["id"]) ||
              (data && data === departments["id"])
            ) {
              selected_value.push(departments["id"]);
              defvalue.push(departments["name"]);
            }
          });
        }
        if (this.props.selectdata.name === "secretary_doctor_ids") {
          this.state.select2options.map((departments, skey) => {
            if (
              (data["id"] && data["id"] === departments["id"]) ||
              (data && data === departments["id"])
            ) {
              selected_value.push(departments["id"]);
              defvalue.push(departments["name"]);
            }
          });
        }
        if (this.props.selectdata.name === "unit") {
          this.state.select2options.map((unit, skey) => {
            if (
              (data["id"] && data["id"] === unit["id"]) ||
              (data["unit_id"] && data["unit_id"] === unit["id"]) ||
              (data && data === unit["id"])
            ) {
              selected_value.push(unit["id"]);
              defvalue.push(unit["name"]);
            }
          });
        }
        if (this.props.selectdata.name === "exclude_services") {
          this.state.select2options.map((service, skey) => {
            if (
              (data["id"] && data["id"] === service["id"])
            ) {
              selected_value.push(service["id"]);
              defvalue.push(service["name"]);
            }
          });
        }
      });
    }
    return (
      <Select
        showSearch
        mode={mode}
        style={{
          width: "100%",
        }}
        placeholder={this.state.selectdata.placeholder}
        defaultValue={defvalue}
        value={selected_value}
        optionFilterProp="children"
        onChange={this.onChange.bind(this)}
        onFocus={this.onFocus.bind(this)}
        onBlur={this.onBlur.bind(this)}
        notFoundContent={
          fetching ? (
            <Spin size="small" />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )
        }
        onSearch={this.onSearch.bind(this)}
        disabled={this.state.selectdata.disable}
        loading={false}
        // menuItemSelectedIcon={< Icon type="check" style={{ color: 'rgba(0,0,0,.25)' }} />}
        dropdownMatchSelectWidth={false}
      >
        {children}
      </Select>
    );
  }
}

export default Select2multiple;
